import { Injectable } from '@angular/core';
@Injectable()
export class AppConfig {
  private serveURL: any = '';
  private defaultImgURL: any = 'assets/default.png';
  constructor() {
    if (location.protocol == 'https:') {
      this.serveURL = '//tr.niit.com/talentReadinessApi/api/tr_'; //Prod API URLc
      // this.serveURL = 'https://tr.niit.com/talentReadinessApi/api/tr_'; //Prod API URLc
      // this.serveURL = 'https://connectnec.niit.com/talentReadinessApi/api/tr_'; //ConnectNec API URL/
      //this.serveURL = 'https://localhost:3000/api/tr_'; //LOCAL API URL
    } else {
      this.serveURL = '//tr.niit.com/talentReadinessApi/api/tr_'; //Prod API URL
      //this.serveURL = 'http://tr.niit.com/talentReadinessApi/api/tr_'; //Prod API URL
      //this.serveURL = 'https://connectnec.niit.com/talentReadinessApi/api/tr_'; //ConnectNec API URL
      //this.serveURL = 'http://localhost:3000/api/tr_'; //LOCAL API URL
    }
  }

  // retrun the server base URL
  public getServerURL() {
    return this.serveURL;
  }

  // validation message for empty jira credential
  public getBlankLoginErrorMsg() {
    return 'Please Enter Your System Login Credential';
  }

  // validation message for wrong jira credential
  public getInvalidDetailsMsg() {
    return 'Some problem occured while connecting to the server.';
  }

  // retrun default Imgage URL
  public getDefaultImgURL() {
    return this.defaultImgURL;
  }
}
